import React from 'react';
import { BarLoader } from "react-spinners";
import { resetPassword } from "../../services/backend_user_auth_service";
import { resetPasswordValidation } from "../../validations/backendUserValidation";


const ResetPassword = () => {

  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const initialValues = {
    password: "",
    confirmPassword: "",
  };

  const handleResetPassword = async (values) => {
    try {
      setLoading(true);

      const res = await resetPassword(values.password, token);

      if (res) {
        setLoading(false)
        toast.success('Password reset successful', toastOptions)
        navigate('/')
      }
    } catch (error) {
      setLoading(false)
      toast.error(error.message, toastOptions)
    }

  };

  return (
    <Container
      fluid
      className="d-flex align-items-center justify-content-center min-vh-100 radial-gradient"
    >
      <Row className="justify-content-center w-100">
        <Col md={8} lg={6} xxl={3}>
          <Card className="mb-0">
            {loading && (
              <div className="mt-3">
                <BarLoader color="#007bff" width="100%" />
              </div>
            )}
            <Card.Body>
              <Link to="/" className="text-center d-block py-3 w-100">
                <h2>Aegis demo</h2>
              </Link>
              <p className="text-center">Reset Password</p>
              <Formik
                initialValues={initialValues}
                validationSchema={resetPasswordValidation}
                onSubmit={(values) => {
                  handleResetPassword(values);
                }}
              >
                {({ errors, touched, isSubmitting, setFieldValue, values }) => (
                  <Form>
                    <BootstrapForm.Group className="mb-3" controlId="email">
                      <Row>
                        <Col md={12} className="mb-2">
                          <BootstrapForm.Group>
                            <BootstrapForm.Label>Password</BootstrapForm.Label>
                            <Field
                              name="password"
                              type="password"
                              className={`form-control ${touched.password && errors.password
                                ? "is-invalid"
                                : ""
                                }`}
                            />
                            {touched.password && errors.password && (
                              <div className="invalid-feedback">
                                {errors.password}
                              </div>
                            )}
                          </BootstrapForm.Group>
                        </Col>
                      </Row>
                      <Row>
                        <Col md={12} className="mb-2">
                          <BootstrapForm.Group>
                            <BootstrapForm.Label>
                              Confirm Password
                            </BootstrapForm.Label>
                            <Field
                              name="confirmPassword"
                              type="password"
                              className={`form-control ${touched.confirmPassword &&
                                errors.confirmPassword
                                ? "is-invalid"
                                : ""
                                }`}
                            />
                            {touched.confirmPassword &&
                              errors.confirmPassword && (
                                <div className="invalid-feedback">
                                  {errors.confirmPassword}
                                </div>
                              )}
                          </BootstrapForm.Group>
                        </Col>
                      </Row>
                    </BootstrapForm.Group>

                    <Button
                      variant="primary"
                      type="submit"
                      className="w-100 py-3 mb-4"

                    >
                      {loading ? "Sending..." : "Reset Password"}
                    </Button>

                  </Form>
                )}
              </Formik>
            </Card.Body>
          </Card>
        </Col>
      </Row>
    </Container>
  );
};

export default ResetPassword;
